/* eslint-disable */
import axios from '../index'

const getSearch = (word, lang) => {
  return axios.get(`search/${word}/${lang}`)
}

const api = { getSearch }


export default api;